import React from 'react';
import { bool, number, object } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { logger } from '@fiverr-private/perseus';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { getPackageById, isRecurringGig, isTriplePackage } from '../../../reducers/packages';
import { isGigWithActiveWorkProcess } from '../../../reducers/workProcess';
import { eligibleForSubscriptionDrawer } from '../../../utils/subscriptionDrawer';
import { isVoiceOver } from '../../../utils/packagesUtils';
import PackageContent from '../../shared/PackageContent';
import TabFooter from './TabFooter';
import PaymentDrawerFooter from './PaymentDrawerFooter';

import './style.scss';

const Content = ({
    id,
    currentPrice,
    isRecurringGig,
    isGigWithActiveWorkProcess
}, { general }) => {

    const { isLimitedEdition } = general;

    // TODO: remove when VO package has a title
    const title = isVoiceOver(general) ? 'gig_page_perseus.packages.order_details' : '';

    const wrapperClass = classNames(
        'content',
        { 'recurring-gig': isRecurringGig }
    );

    const inSubscriptionDrawer = isRecurringGig && eligibleForSubscriptionDrawer();
    const showPaymentDrawer = isGigWithActiveWorkProcess || inSubscriptionDrawer;

    return (
        <div className={wrapperClass}>
            <PackageContent id={id} showPrice={!isLimitedEdition} title={title ? <I18n k={title}/> : ''}/>
            {showPaymentDrawer ? (
                <PaymentDrawerFooter/>
            ) : (
                <TabFooter currentPrice={currentPrice}/>
            )}
        </div>
    );
};

Content.propTypes = {
    id: number,
    currentPrice: number,
    isRecurringGig: bool,
    isGigWithActiveWorkProcess: bool
};

Content.contextTypes = {
    general: object
};

const mapStateToProps = (state, ownProps) => {
    const { packages } = state;
    const packageData = getPackageById(packages, ownProps.id);
    const triplePackage = isTriplePackage(packages);

    if (!packageData.title) {
        const { url } = getContext();
        logger.warn({
            message: 'missing package title',
            url,
            is_triple_package: triplePackage
        });
    }

    return {
        ...packageData,
        isRecurringGig: isRecurringGig(packages),
        isGigWithActiveWorkProcess: isGigWithActiveWorkProcess(state)
    };
};

const ContentConnect = connect(mapStateToProps)(Content);

const TabContent = ({ id }) => (
    <ContentConnect id={id}/>
);

export { Content };
export default TabContent;
